import React from "react";
import Label from "components/general/Label"
import SportCode from "components/common/SportCode";

export function CompetitorBlockNoData(competitor) {
    const isQFNL = competitor?.data?.eventUnit?.code.includes('QFNL')
    return (
        <div className=' d-flex flex-row justify-content-start'>
            {competitor?.cp_code === 'BYE'
                ? <SportCode discipline='RU7' entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} />
                : !competitor.cp_prev_wlt && isQFNL
                    ? competitor?.cp_prev_pos
                    : ''
            }
        </div>
    )
}